module.exports = __webpack_public_path__ + "img/settings-additional.7de819dc.svg";